<template>

  <section class="o-section">
    <div class="o-section__wrapper is-bottom-left" ref="wrapper">

      <Leafs type="scene" />

      <div class="o-section__text" v-if="active">
        <div ref="textA" data-scene="5a">
          <div v-for="(line, index) in copy.left" v-html="line" :key="`left-${index}`"></div>
        </div>
        <div ref="textB" data-scene="5b">
          <div v-for="(line, index) in copy.right" v-html="line" :key="`right-${index}`"></div>
        </div>
      </div>

      <div class="o-section__figure-wrapper anim-figure-scene-5">
        <figure class="o-section__figure" ref="figureC" data-scene="5c">
          <Img :src="require('@/assets/scene5/spread5_c.png')" filename="spread5_c" />
        </figure>

        <figure class="o-section__figure" ref="figureA2" data-scene="5a2">
          <Img :src="require('@/assets/scene5/spread5_a2.png')" filename="spread5_a2" />
        </figure>

        <figure class="o-section__figure" ref="figureA" data-scene="5a">
          <Img :src="require('@/assets/scene5/spread5_a.png')" filename="spread5_a" />
        </figure>

        <figure class="o-section__figure" ref="figureB" data-scene="5b">
          <Img :src="require('@/assets/scene5/spread5_b.png')" filename="spread5_b" />
        </figure>
      </div>
    </div>
  </section>

</template>

<script>
import Img from '@/components/Img'
import Leafs from '@/components/Leafs'

export default {
  name: 'Scene5',
  props: ['options', 'active', 'copy', 'disableBlur'],

  mounted () {
    this.$root.$on('startScene5', () => {
      this.init()
    })
  },

  methods: {
    init () {
      this.$anime({
        targets: [this.$refs.figureA, this.$refs.figureA2],
        translateX: ['-60px', '0'],
        translateY: ['-10px', '20px'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureA2.querySelector('div'),
        translateX: ['-15px', '0'],
        duration: this.options.durationRegular,
        loop: true,
        direction: 'alternate',
        easing: this.options.easing
      })

      if (this.disableBlur) {
        this.$anime({
          targets: [this.$refs.figureA, this.$refs.figureA2],
          opacity: [0, 1],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureA2,
          opacity: [0, 1],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureC,
          opacity: [0, 1],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      } else {
        this.$anime({
          targets: [this.$refs.figureA, this.$refs.figureA2],
          filter: ['blur(5px)', 'blur(0px)'],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureA2,
          filter: ['blur(5px)', 'blur(0px)'],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureC,
          filter: ['blur(25px)', 'blur(0px)'],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      }

      this.$anime({
        targets: this.$refs.figureB,
        translateX: ['80px', '0'],
        translateY: ['10px', '0'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureC,
        translateX: ['-10px', '0'],
        translateY: ['-10px', '0'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })
    }
  },

  components: {
    Leafs,
    Img
  }
}
</script>
